define('services/AppRoutes',['plugins/router', 'services/navigation', 'services/logger', 'durandal/system'], function (router, navigation, logger, system) {
    var ArViewModel = {


        //-------------Configuration Module Starts Here-------------------
        NavigateClientDetails: function () {
            try {
                router.navigate("configuration/ClientDetails", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateClientDetails() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateOrganizationalLevels: function () {
            try {
                router.navigate("configuration/OrganizationalLevels", true);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateOrganizationalLevels() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRATaxonomySetup: function () {
            try {
                router.navigate("configuration/RATaxonomySetup", true);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRATaxonomySetup() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateBusinessUnit: function () {
            try {
                router.navigate("configuration/BusinessUnit", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateBusinessUnit() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateYearSetup: function () {
            try {
                router.navigate("Calculations/YearSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateYearSetup method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateToEmailTemplate: function () {
            try {
                router.navigate("configuration/EmailTemplate", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToEmailTemplate method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateToUserSupportTemplates: function () {
            try {
                router.navigate("configuration/UserSupportTemplates", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToUserSupportTemplates method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateToEmailReminderSetup: function () {
            try {
                router.navigate("configuration/EmailReminderSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToEmailReminderSetup method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateResponsibilityGroup: function () {
            try {
                router.navigate("survey/ResponsibilityGroup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateResponsibilityGroup method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateUserGroupManagement: function () {
            try {
                router.navigate("configuration/UserGroup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateUserGroupManagement method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateReportManagement: function () {
            try {
                router.navigate("Calculations/ReportManagement", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateReportManagement method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateUserRole: function () {
            try {
                router.navigate("configuration/UserRole", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateUserRole() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateUserGroup: function () {
            try {
                router.navigate("configuration/UserGroup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateUserGroup() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateCustomReportManagment: function () {
            try {
                router.navigate("Calculations/CustomWReport", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateCustomReportManagment() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateQuantConfig: function () {
            try {
                router.navigate("Calculations/QuantConfig", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateQuantConfig() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRoleManagement: function () {
            try {
                router.navigate("configuration/RoleManagement", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRoleManagement() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRisksAreasandfactors: function () {
            try {
                router.navigate("configuration/RisksAreasfactors", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRisksAreasandfactors() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRiskLevel: function () {
            try {
                router.navigate("configuration/RiskLevel", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRiskLevel() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateQualitativeSetup: function () {
            try {
                router.navigate("configuration/QualitativeSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateQualitativeSetup() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateConfigurationManagement: function () {
            try {
                router.navigate("configuration/ConfigurationManagement", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateConfigurationManagement() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateInherentSetup: function () {
            try {
                router.navigate("configuration/InherentSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateInherentSetup() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateBlueprintSetup: function () {
            try {
                router.navigate("survey/BlueprintSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateBlueprintSetup() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        //-------------Configuration Module Ends Here-------------------

        //-------------HeatMaps Module Starts Here----------------------
        NavigateInherentRiskHeatMap: function () {
            try {
                router.navigate("HeatMaps/InherentRiskHeatMap", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateInherentRiskHeatMap() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        //-------------HeatMaps Module Ends Here----------------------

        //-------------Survey Module Starts Here-----------------------
        NavigateConfigureSurvey: function () {
            try {
                router.navigate("survey/ConfigureSurvey", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateConfigureSurvey() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateAMLControlAreaSetup: function () {
            try {
                router.navigate("survey/AMLControlAreaSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateAMLControlAreaSetup() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateSurveyTracking: function () {
            try {
                router.navigate("survey/SurveyTracking", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateSurveyTracking() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateWorkflowConfigure: function () {
            try {
                router.navigate("survey/WorkflowConfigure", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateWorkflowConfigure() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateSurveyDashBoard: function () {
            try {
                router.navigate("survey/SurveyDashBoard", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateSurveyDashBoard() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateGenericDashBoard: function () {
            try {
                router.navigate("/Dashboard", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateGenericDashBoard() method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        //-------------Survey Module Ends Here-----------------------

        //-------------Weightings_Thresholds Module Starts Here---------
        NavigateAMLInherentWeightings: function () {
            try {
                router.navigate("Weightings_Thresholds/AMLInherentWeightings", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateAMLInherentWeightings method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateAMLControlsWeightings: function () {
            try {
                router.navigate("Weightings_Thresholds/AMLControlsWeightings", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateAMLControlsWeightings method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateAMLThresholds: function () {
            try {
                router.navigate("Weightings_Thresholds/AMLThresholds", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateAMLThresholds method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateAMLOrganizationalLevelWeightings: function () {
            try {
                router.navigate("Weightings_Thresholds/AMLOrganizationalLevelWeightings", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateAMLInherentWeightings method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateOrganizationalLevelWeightings: function () {
            try {
                router.navigate("Weightings_Thresholds/OrganizationalLevelWeightings", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateOrganizationalLevelWeightings method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateControlsWeightings: function () {
            try {
                router.navigate("Weightings_Thresholds/ControlsWeightings", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateControlsWeightings method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateInherentWeightings: function () {
            try {
                router.navigate("Weightings_Thresholds/InherentWeightings", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateInherentWeightings method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigatePCSThresholds: function () {
            try {
                router.navigate("Weightings_Thresholds/PCSThresholds", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigatePCSThresholds method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },


        //-------------Weightings_Thresholds Module Ends Here---------

        //-------------AML Risk Assessment Module Starts Here----------
        //NavigateAMLInherentRiskAssessment: function () {
        //    try {
        //        router.navigate("AMLRiskAssessment/AMLInherentRiskAssessment", true);
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: NavigateAMLInherentRiskAssessment method in AppRoutes.js';
        //        logger.logMessage(msg);
        //    }
        //},
        //NavigateAMLControlRiskAssessment: function () {
        //    try {
        //        router.navigate("AMLRiskAssessment/AMLControlRiskAssessment", true);
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: NavigateAMLControlRiskAssessment method in AppRoutes.js';
        //        logger.logMessage(msg);
        //    }
        //},

        ////------------------------------------------- RA Screen Reports--------------------------//
        NavigateRAInherentReport: function () {
            try {
                router.navigate("reporting/RAInherentReport", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateAMLInherentRiskAssessment method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRAControlsReport: function () {
            try {
                router.navigate("reporting/RAControlsReport", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateAMLControlRiskAssessment method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        //------------------------------------------- RA Screen Reports--------------------------//

        //-------------AML Risk Assessment Module Ends Here----------

        //-------------Reporting Module Starts Here----------

        NavigateSummaryReport: function () {
            try {

                router.navigate("Reporting/SummaryReport", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateSummaryReport method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateReports: function () {
            try {
                router.navigate("reporting/Reports", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateReporting method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateWordReport: function () {
            try {
                router.navigate("reporting/WordReport", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateWordReport method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },


        //-------------Reporting Module Ends Here----------

        //-------------Calculation Module Starts Here----------

        NavigateCalculationStatus: function () {
            try {
                router.navigate("Calculations/CalculationStatus", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateCalculationStatus method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        //-------------Reporting Module Ends Here----------
        //------------VisualAnalytics module starts here---------------
        NavigateExecutiveRiskDashboard: function () {
            try {
                router.navigate("Reporting/ExecutiveRiskDashboard", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ExecutiveRiskDashboard method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateInherentHeatmapAnalysis: function () {
            try {
                router.navigate("VisualAnalytics/InherentHeatMapAnalysis", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateInherentHeatmapAnalysis method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateValidationReports: function () {
            try {
                router.navigate("VisualAnalytics/ValidationReports", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateValidationReports method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRiskDashBoard: function () {
            try {
                router.navigate("VisualAnalytics/RiskDashBoard", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRiskDashBoard method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        //-------------VisualAnalytics Module End here--------------------

        //------------ActionTracking module starts here---------------

        NavigateActionTrackerConfiguraton: function () {
            try {
                router.navigate("ActionTracker/ConfigureActionTracker", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateActionTrackerConfiguraton method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateActionPlanManagement: function () {
            try {
                router.navigate("ActionTracker/ActionPlanManagement", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateActionPlanManagement method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateAssignActionItems: function () {
            try {
                router.navigate("/ActionTracker/AssignActionItems", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateAssignActionItems method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateActionItemDashboard: function () {
            try {
                router.navigate("/ActionTracker/ActionItemDashboard", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateActionItemDashboard method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateActionTracking: function () {
            try {
                router.navigate("/ActionTracker/ActionTracking", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateActionTracking method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        //-------------ActionTracking Module End here--------------------

        //-------------Socialization Module Starts here--------------------
        NavigateAdministration: function () {
            try {
                router.navigate("/RaSocialization/Administration", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateActionTracking method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateDashboard: function () {
            try {
                router.navigate("/RaSocialization/Dashboard", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateActionTracking method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        //------------ Risk Rating module starts here---------------
        NavigateAttributeConfiguration: function () {
            try {
                router.navigate("RiskRating/AttributeConfiguration", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateAttributeConfiguration method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRiskRatingConfiguration: function () {
            try {
                router.navigate("RiskRating/RiskRatingConfiguration", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRiskRatingConfiguration method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRiskRatingSetup: function () {
            try {
                router.navigate("RiskRating/RiskRatingSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRiskRatingSetup method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRiskRatingFactorSetup: function () {
            try {
                router.navigate("RiskRating/RiskRatingFactorSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRiskRatingFactorSetup method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRRConfigureSurvey: function () {
            try {
                router.navigate("RiskRating/RRPCSConfigure", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRRConfigureSurvey method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRiskRatingDashboard: function () {
            try {
                router.navigate("RiskRating/RiskRatingDashboard", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRiskRatingDashboard method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateRiskRatingAnalysis: function () {
            try {
                router.navigate("RiskRating/RiskRatingAnalysis", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRiskRatingAnalysis method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        //------------Risk Rating module ends here---------------

        //-------------Socialization Module End here--------------------

        //------------Product Eisk Rating module starts here---------------
        NavigateProductConfiguration: function () {
            try {
                router.navigate("ProductRiskRating/ProductConfiguration", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateProductConfiguration method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateProductRatingSetup: function () {
            try {
                router.navigate("ProductRiskRating/ProductRatingSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateProductRatingSetup method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateProductRiskFactorSetup: function () {
            try {
                router.navigate("ProductRiskRating/ProductRiskFactorSetup", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateRiskFactorSetup method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateProductRiskRatingDashboard: function () {
            try {
                router.navigate("ProductRiskRating/ProductRiskRatingDashboard", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateProductRiskRatingDashboard method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateProductRiskRatingAnalysis: function () {
            try {
                router.navigate("ProductRiskRating/ProductRiskRatingAnalysis", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateProductRiskRatingAnalysis method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        //------------Product Eisk Rating module ends here---------------

        //-------------Common Pages Starts Here----------------------------
        NavigateLanding: function Landing() {
            try {
                router.navigate("Landing", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateLanding method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },
        NavigateProjectLanding: function ProjectLanding() {
            try {
                router.navigate("ProjectLanding", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateProjectLanding method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateAuthorizeMFA: function AuthorizeMFA() {
            try {
                router.navigate("AuthorizeMFA", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AuthorizeMFA method in AppRoutes.js';
                logger.logMessage(msg);
            }
        },

        NavigateUserManual: function UserManual() {
            try {
                router.navigate("UserManual", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UserManual method in AppRoutes.js';
                logger.logMessage(msg);
            }
        }
        //-------------Common Pages Ends Here----------------------------
    };
    return ArViewModel;
});
